const regexDestinoOrigem = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[\dXs#?*+\-.[\]]{0,20}$/g.test(value)
}

export const validateRegexData = {
  regexVisualOrigem: { regexDestinoOrigem },
  regexVisualDestino: { regexDestinoOrigem },
}

export const validateRegexComputed = {
  regexVisualOrigemErrors() {
    const errors = []
    if (!this.$v.form.regexVisualOrigem.$dirty) return errors
    !this.$v.form.regexVisualOrigem.regexDestinoOrigem && errors.push('Caractere inválido.')
    return errors
  },
  regexVisualDestinoErrors() {
    const errors = []
    if (!this.$v.form.regexVisualDestino.$dirty) return errors
    !this.$v.form.regexVisualDestino.regexDestinoOrigem && errors.push('Caractere inválido.')
    return errors
  },
}
